(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('FontManagement', FontManagement);

    FontManagement.$inject = ['$resource'];

    function FontManagement ($resource) {
        var resourceUrl =  'manager/' + 'api/font-managements/:path/:id';

        return $resource(resourceUrl, {}, {
            "getAll1": {
                method: "POST",
                params: {
                    path: "getAll1"
                }
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                },
            },
            "getCss": {
                method: "GET",
                params: {
                    path: "getCss"
                }
            },
            "upload": {
                method: "POST",
                params: {
                    path: "upload"
                }
            },
            "defaultShow":{
                method:"GET",
                params:{
                    path:"defaultShow"
                }
            },
            "getAll": {
                method: "POST",
                params: {
                    path: "getAll"
                }
            },
            "updateType": {
                method: "GET",
                params: {
                    path: "updateType"
                }
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'updateLanguage':{
                method: 'POST',
                params:{
                    path:"updateLanguage"
                },
            }
        });
    }
})();
